import React from "react";
import { Link, useHistory } from "react-router-dom";
import { useSnackbar } from "notistack";
import Icon from "./Icon";
import { clearSession, useSession } from "../session";
import { money } from "../utils";
import "./Header.css";

export const Logo = ({ light = false }) => (
  <Link to="/" className={`logo ${light ? "logo-light" : ""}`} aria-label="QKart home">
    <span className="logo-mark" aria-hidden="true" />
    <span className="logo-word" aria-hidden="true">
      QKart
    </span>
  </Link>
);

// `children` fills the middle slot (search box on the shop, progress on checkout).
const Header = ({ children }) => {
  const session = useSession();
  const history = useHistory();
  const { enqueueSnackbar } = useSnackbar();

  const logout = () => {
    clearSession();
    enqueueSnackbar("You're logged out", { variant: "info" });
    history.push("/");
  };

  return (
    <header className="site-header">
      <div className="container site-header-inner">
        <Logo />
        <div className="site-header-middle">{children}</div>
        <div className="site-header-account">
          {session.loggedIn ? (
            <>
              <span className="wallet-chip" title="Wallet balance">
                <Icon name="wallet" size={17} />
                <span className="sr-only">Wallet balance </span>
                {money(session.balance)}
              </span>
              <span className="user-chip">
                <span className="avatar" aria-hidden="true">
                  {(session.username || "?").charAt(0).toUpperCase()}
                </span>
                <span className="user-name">{session.username}</span>
              </span>
              <button type="button" className="btn btn-ghost" onClick={logout}>
                Log out
              </button>
            </>
          ) : (
            <>
              <Link to="/login" className="btn btn-ghost">
                Log in
              </Link>
              <Link to="/register" className="btn btn-primary">
                Register
              </Link>
            </>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
